/** TikTok /advertiser/info/ status badge (cached on balance refresh). */
export function AdvertiserStatusCell({
  status,
}: {
  status?: string | null
}) {
  if (!status) {
    return <span className="text-[#666]">—</span>
  }

  const key = status.toUpperCase()
  const meta = ADVERTISER_STATUS_STYLES[key] ?? matchAdvertiserStatus(key)
  if (!meta) {
    return (
      <span className="inline-block rounded-full border border-gray-600/40 bg-gray-800/60 px-2.5 py-0.5 text-[10px] font-semibold text-gray-300">
        {status}
      </span>
    )
  }

  return (
    <span
      className={`inline-block rounded-full border px-2.5 py-0.5 text-[10px] font-semibold ${meta.cls}`}
    >
      {meta.label}
    </span>
  )
}

const ADVERTISER_STATUS_STYLES: Record<string, { label: string; cls: string }> = {
  STATUS_ENABLE: {
    label: "Approved",
    cls: "bg-green-900/40 text-green-300 border-green-600/40",
  },
  ENABLE: {
    label: "Approved",
    cls: "bg-green-900/40 text-green-300 border-green-600/40",
  },
  STATUS_LIMIT: {
    label: "Suspended",
    cls: "bg-red-900/40 text-red-300 border-red-600/40",
  },
  LIMIT: {
    label: "Suspended",
    cls: "bg-red-900/40 text-red-300 border-red-600/40",
  },
}

function matchAdvertiserStatus(
  key: string,
): { label: string; cls: string } | null {
  if (key.includes("ENABLE")) {
    return ADVERTISER_STATUS_STYLES.STATUS_ENABLE
  }
  if (key.includes("LIMIT")) {
    return ADVERTISER_STATUS_STYLES.STATUS_LIMIT
  }
  return null
}
